import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconViewer.tsx
const IconViewer = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 5v2h9.13l1.868-2zm12 1.857L18 9v6h2zM22 15v2l-4 4H2V7l4-4h16v12M6 5.828 4.828 7H6zM6 9H4v10l2-2zm2.828 8-2 2H16v-2zM18 17v1.172L19.172 17zm-2-2V9H8v6z",
		clipRule: "evenodd"
	})]
});
var IconViewer_default = forwardRef(IconViewer);
//#endregion
export { IconViewer_default as default };
